import React from 'react';
import { AlertCircle, FileX } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  message?: string;
  onBack: () => void;
  /** When true, shows "report não existe" style with title + description */
  reportNotFound?: boolean;
  title?: string;
  description?: string;
  backButtonLabel?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  onBack,
  reportNotFound = false,
  title,
  description,
  backButtonLabel = 'Voltar para Reports',
}) => {
  const showTitleDescription = (title != null && title !== '') || (description != null && description !== '');
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center py-24 px-4">
      <div className="flex flex-col items-center justify-center text-center max-w-sm">
        <div className="flex justify-center mb-4">
          {reportNotFound ? (
            <FileX className="w-10 h-10 text-gray-500" />
          ) : (
            <AlertCircle className="w-8 h-8 text-red-600" />
          )}
        </div>
        {showTitleDescription ? (
          <>
            {title && <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>}
            {description && <p className="text-gray-600 mb-6">{description}</p>}
          </>
        ) : (
          <p className="text-lg text-gray-700 mb-6">{message}</p>
        )}
        <Button onClick={onBack} variant="dark">
          {backButtonLabel}
        </Button>
      </div>
    </div>
  );
};
